import { smartCatalog } from '@/API'
import $ from 'jquery'

const defaultConstants = {
  from: 'от',
  to: 'до',
  application: 'Заявка',
  search: 'Поиск',
  'application-name': 'Имя',
  'application-phone': 'Телефон',
  'application-comment': 'Комментарий',
  'something-went-wrong': 'Что-то пошло не так',
  'application-has-been-sent': 'Заявка отправлена',
  'sign-up-for-viewing': 'Записаться на просмотр',
  'reset-filter': 'Сбросить фильтр',
  'items-selected': 'Выбрано элементов',
  'empty-field': 'Поле не заполнено',
  'no-suitable-objects': 'Нет подходящих объектов',
}

export default {
  namespaced: true,
  state: {
    account: {},
  },
  getters: {
    getAccount(state) {
      return state.account
    },
    getPresentationConstantTranslationByKey(state) {
      return (key) => {
        return state.account.locale?.presentation?.constants
          ?.find(c => c.target === key)?.translation || defaultConstants[key]
      }
    },
    getCatalogConstantTranslationByKey(state) {
      return (key) => {
        return state.account.locale?.catalog?.constants
          ?.find(c => c.target === key)?.translation || defaultConstants[key]
      }
    },
    getTranslatedParam(state) {
      return (param) => {
        let translatedParam = param?.split('#')[0].trim()
      
        state.account.locale?.general?.forEach(g => {
          translatedParam = translatedParam.replaceAll(g.target, g.translation)
        })
        
        return translatedParam
      }
    }
  },
  mutations: {
    SET_ACCOUNT(state, payload) {
      state.account = payload
    }
  },
  actions: {
    async loadAccount({ commit } , { domain, _id }) {
      try {
        const data = await smartCatalog.getAccount({ domain, _id })
        document.title = data.name

        if (data.script) {
          $(document.body).append($(data.script))
        }
        commit('SET_ACCOUNT', data)
      } catch (error) {
        console.error(error)
        console.error(error.response)
      }
    }
  }
}
